import { ENV_VARIABLES } from '@/constants';
import { AuthProvider } from '@/libs';

type Props = {
  children: React.ReactNode;
};

const AppAuthProvider = ({ children }: Props) => (
  <AuthProvider
    clientAuthorizationToken={ENV_VARIABLES.AUTH_SECRET}
    clientId={ENV_VARIABLES.CLIENT_ID.replaceAll('-', '')}
    redirectUri={globalThis.location.origin}
    accountsUri={ENV_VARIABLES.ACCOUNTS_URL}>
    {children}
  </AuthProvider>
);

export default AppAuthProvider;
